import React from 'react';
import { Button } from '../ui/Button';
import { SelectField, TextAreaField, TextField } from '../ui/Field';
import { FormCard, FormError, FormFooterNote, FormSuccess } from './FormShell';
import { useLeadSubmit } from '../../hooks/useLeadSubmit';

/**
 * Financiación de una unidad USADA del catálogo.
 * Se guarda en la misma hoja "Financiación" que el resto de las consultas.
 */
export function FinanciarUsadoForm({
  vehiculoInicial = ''
}: {
  vehiculoInicial?: string;
}) {
  const {
    status,
    sending,
    submitted,
    reference,
    submitForm,
    retry
  } = useLeadSubmit('financiacionUsado', 'Financiación');
  if (submitted) {
    return <FormSuccess message="Gracias por tu consulta. Un asesor de VCARS se comunicará con vos a la brevedad." reference={reference} data-id="element-89" data-mp="1fir4zczg094t" />;
  }
  return <FormCard title="Financiá tu próximo usado" lead="Contanos qué unidad te interesa y con qué anticipo contás. Evaluamos tu perfil y te armamos el plan de cuotas." data-id="element-90" data-mp="432foeypuy0u">
      {status === 'error' ? <FormError onRetry={retry} data-id="element-91" data-mp="1wo45unop916" /> : null}
      <form className="grid gap-4 sm:grid-cols-2" onSubmit={submitForm} data-id="element-92" data-mp="3t2gvpsh0tz2n">
        <TextField id="nombre" label="Nombre y apellido" required autoComplete="name" data-id="element-93" data-mp="3t4jtwzsbuyig" />
        <TextField id="telefono" label="Teléfono" type="tel" required autoComplete="tel" data-id="element-94" data-mp="bvwri4o1npek" />
        <TextField id="email" label="Email" type="email" required autoComplete="email" data-id="element-95" data-mp="6tnyx9f32pcz" />
        <TextField id="cuil" label="CUIL" required inputMode="numeric" pattern="[0-9\-\s]{11,13}" maxLength={13} placeholder="20-12345678-3" title="Ingresá los 11 números de tu CUIL" data-id="element-96" data-mp="ktpbvn8mhn8t" />

        <TextField id="vehiculoInteres" label="Usado que querés financiar" required defaultValue={vehiculoInicial} placeholder="Ej: Peugeot 5008 Allure 2013" className="sm:col-span-2" data-id="element-97" data-mp="pl72pigxm7g2" />

        <TextField id="anticipo" label="Anticipo disponible" required placeholder="Ej: USD 5.000 o $6.000.000" data-id="element-98" data-mp="zhtktzhvikee" />
        <TextField id="montoFinanciar" label="Monto que necesitás financiar" placeholder="Ej: $10.000.000" data-id="element-99" data-mp="1bn8xrp1k0aqz" />
        <SelectField id="cuotas" label="Cuotas deseadas" options={['12 cuotas', '18 cuotas', '24 cuotas', '36 cuotas', '48 cuotas', 'A definir']} required data-id="element-100" data-mp="1gjfvwvnpkhyd" />
        <SelectField id="permutaParteDePago" label="¿Entregás un usado en parte de pago?" options={['Sí', 'No', 'A definir']} required data-id="element-101" data-mp="1pfyp88zuq7vh" />
        <SelectField id="clienteBancario" label="¿Sos cliente activo bancario?" options={['Sí, con cuenta y movimientos', 'Sí, pero sin movimientos', 'No', 'No estoy seguro']} required data-id="element-102" data-mp="1z9p5wrpqle0m" />
        <SelectField id="ingresos" label="¿Cómo acreditás ingresos?" options={['Recibo de sueldo en relación de dependencia', 'Monotributista', 'Autónomo / responsable inscripto', 'Jubilado o pensionado', 'Otro']} required data-id="element-103" data-mp="9wbyuuq8pbvt" />

        <TextAreaField id="mensaje" label="Comentarios adicionales" className="sm:col-span-2" placeholder="Contanos cualquier dato que nos ayude a armar tu propuesta." data-id="element-104" data-mp="2efbjjxbqh8kt" />

        <div className="sm:col-span-2" data-id="element-105" data-mp="363vbcbwqomqt">
          <Button type="submit" size="lg" className="w-full sm:w-auto" disabled={sending} data-id="element-106" data-mp="3244g9w06jkgh">
            {sending ? 'Enviando consulta…' : 'Quiero financiar este usado'}
          </Button>
          <FormFooterNote data-id="element-107" data-mp="2s6ghmuzgdst1">
            Evaluación rápida y sin compromiso. Te acompañamos durante toda la operación.
          </FormFooterNote>
        </div>
      </form>
    </FormCard>;
}